import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronRightIcon } from '@/components/icons/ChevronRightIcon';
import { RECIPES_PATH } from '@/constants/paths';
import { RECIPE_CARD_FOOD } from '@/constants/images';
import { Sparkles } from 'lucide-react';
import { cn } from '@/utils/styles';

interface MyRecipesSectionProps {
  className?: string;
}

export const MyRecipesSection: React.FC<MyRecipesSectionProps> = ({ className }) => {
  const navigate = useNavigate();

  const handleDigInClick = () => {
    navigate(RECIPES_PATH);
  };

  return (
    <div className={cn('bg-zinc-100', className)}>
      <div className="page-container !py-12">
        <div className="w-full">
                  <div
            className="bg-gradient-to-b from-[#3c7c27] to-[#a9d563] rounded-[20px] min-h-[180px] sm:h-[180px] relative overflow-hidden cursor-pointer hover:shadow-lg transition-shadow duration-200"
            onClick={handleDigInClick}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleDigInClick();
              }
            }}
          >
            {/* Content - capped width on larger screens, fluid on mobile */}
            <div className="relative z-10 h-full px-5 py-6 flex flex-col justify-between w-full max-w-[423px] pr-[120px] sm:pr-5">
              <div className="flex flex-col gap-3">
                {/* Header with title and filter */}
                <div className="flex items-center gap-2 flex-wrap">
                  <h2 className="typography-h1 text-white whitespace-nowrap">
                    My Recipes
                  </h2>

                  {/* New pill */}
                  <div 
                    className="inline-flex items-center rounded-full px-2 h-6 flex-shrink-0"
                    style={{ background: 'linear-gradient(90deg, #9A71D0 0%, #6159FE 100%)' }}
                  >
                    <Sparkles aria-hidden className="w-2.5 h-2.5 sm:w-3 sm:h-3 text-white mr-1" strokeWidth={2} />
                    <span className="typography-caption2 text-white">New</span>
                  </div>
                </div>

                {/* Description */}
                <p className="typography-body text-white/90">
                  Delicious recipes personalized to your Viome results.
                </p>
              </div>

              {/* Dig in button */}
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleDigInClick();
                }}
                className="group flex items-center gap-1.5 bg-transparent px-0 py-2 self-start focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/20"
                aria-label="View personalized recipes"
              >
                <span className="typography-title text-white transition-opacity group-hover:opacity-90 group-active:opacity-80">
                  Dig in
                </span>
                <ChevronRightIcon className="text-white w-5 h-5 transition-opacity group-hover:opacity-90 group-active:opacity-80" />
              </button>
            </div>

            {/* Salad Image - fixed to right side of card */}
            <div className="absolute right-0 top-0 bottom-0 w-[140px] sm:w-[280px] md:w-[400px] pointer-events-none overflow-hidden rounded-br-[20px] rounded-tr-[20px]">
              <img
                src={RECIPE_CARD_FOOD}
                alt="Fresh salad"
                className="w-full h-full object-cover sm:object-none sm:object-left"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyRecipesSection;